import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureAttribution } from "@/lib/attribution";

// Capture UTM params + referrer on first paint, before any nav.
captureAttribution();

createRoot(document.getElementById("root")!).render(<App />);
